import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=36475d1e&scoped=true"
import script from "./Perfil.vue?vue&type=script&lang=js"
export * from "./Perfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36475d1e",
  null
  
)

export default component.exports